export default {"src":"/_next/static/media/ic-tip-blue.1c1e0b55.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};